//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { XIcon } from 'vue-feather-icons'
import InviteToJobForm from '@/components/client/InviteToJobForm'
import { escrowStatuses } from 'ct-constants'
import AgentPayoutAddressForm from '@/components/agents/AgentPayoutAddressForm'

const INVITATION_TAB = 'invitation'
const ADDRESS_TAB = 'address'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'InviteToJobModal',
  components: {
    AgentPayoutAddressForm,
    InviteToJobForm,
    XIcon
  },
  props: {
    freelancer: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      step: INVITATION_TAB,
      selectedTask: null,
      tabs: {
        INVITATION: INVITATION_TAB,
        ADDRESS: ADDRESS_TAB
      }
    }
  },
  computed: {
    isAgent () {
      return this.$store.getters['user/isAgent']
    }
  },
  destroyed () {
    this.step = INVITATION_TAB
  },
  methods: {
    showModal () {
      this.$refs['invitation-modal'].show()
    },
    hideModal () {
      this.$refs['invitation-modal'].hide()
    },

    /**
     * Check if payout address form need to be displayed
     * @param {Object} selectedTask
     */
    routeContent (selectedTask) {
      if (this.isAgent && !selectedTask?.agentCryptoPayoutAddress && selectedTask?.escrowStatus === escrowStatuses.ESCROW_SET) {
        this.selectedTask = selectedTask
        this.step = ADDRESS_TAB
      } else {
        this.step = INVITATION_TAB
        this.hideModal()
      }
    }
  }
}
